import * as React from 'react';
import { useSelector } from 'react-redux';

import { getTripInfo } from '../../../selectors/newReview/getTripInfo';
import { TripInfoBanner } from '../../../components/DailyrentNewReview/TripInfoBanner';

/**
 * Контейнер для отображения информации о поездке в модалке создания отзыва
 * Получает tripInfo из Redux state и отображает его если данные есть
 */
export const TripInfoBannerContainer: React.FC = () => {
  const tripInfo = useSelector(getTripInfo);

  if (!tripInfo) {
    return null;
  }

  return <TripInfoBanner tripInfo={tripInfo} />;
};
